









import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ProfileLink extends Vue {
	@Prop({ type: String }) name!: string;
	@Prop({ type: Number }) guid!: number;
	@Prop({ required: true, type: Number }) realmId!: number;

	get link() {
	    return this.name ? `/armory/${this.realmId}/characters/${this.name}` : `/armory/${this.realmId}/characters/${this.guid}`;
	}
}
